const euroFormatter = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatEuroPrice = (price: number | null): string =>
  price !== null ? euroFormatter.format(price) + '€' : '- €';

const euroPerkWhFormatter = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 5,
});

export const formatEuroPricePerkWh = (price: number): string =>
  `${euroPerkWhFormatter.format(price)}€/kWh`;

const decimalFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });

export const formatDecimal = (value: number): string => decimalFormatter.format(value);

export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/\s/g, '');
  if (cleaned.startsWith('+33')) {
    return cleaned;
  }

  if (cleaned.startsWith('0')) {
    return '+33' + cleaned.slice(1);
  }

  if (/^\d{9}$/.test(cleaned)) {
    return '+33' + cleaned;
  }
  return cleaned;
};

export const maskIban = (iban: string): string => {
  const cleaned = iban.replace(/\s/g, '');
  if (cleaned.length <= 7) {
    return cleaned;
  }
  return `${cleaned.slice(0, 4)} •••• ${cleaned.slice(-3)}`;
};
